<template>
  <div class="defect-serverity">
    <div class="defect-serverity-item">
      <div class="label">{{ $l("label_location_code") || "位置代码" }}</div>
      <div class="value">{{ item.categoryOptionNo }}</div>
    </div>
    <div class="defect-serverity-item">
      <div class="label">{{ $l("label_location_name") || "位置名称" }}</div>
      <div class="value">
        {{ item.categoryOptionName }} / {{ item.categoryOptionNameEn }}
      </div>
    </div>
    <div class="defect-serverity-item" style="border-bottom: 0px !important;">
      <div class="label" style="height: 40px !important;">
        {{ $l("label_ds_level") || "疵点等级" }}
      </div>
      <div class="value">
        <el-radio-group v-model="defectOptionCode">
          <el-radio
            :label="ds.dfDefinitionCategoryCode"
            v-for="(ds, index) in defectSeverities"
            :key="index"
            >{{ ds.categoryOptionName }} /
            {{ ds.categoryOptionNameEn }}</el-radio
          >
        </el-radio-group>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    defectSeverities: {
      type: Array,
      default: () => [],
    },
    defectOption: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    defectSeverityMap() {
      const tmp_map = {};
      this.defectSeverities.forEach((e) => {
        tmp_map[e.dfDefinitionCategoryCode] = e;
      });
      return tmp_map;
    },
  },
  watch: {
    defectOption: {
      handler() {
        this.defectOptionCode = this.defectOption[
          this.item?.dfDefinitionCategoryCode
        ]?.defectOptionCode;
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      defectOptionCode: "",
    };
  },
  methods: {
    getData() {
      if (!this.defectOptionCode) {
        return {
          locationOptionCode: this.item?.dfDefinitionCategoryCode,
          locationOptionNo: this.item?.categoryOptionNo,
        };
      }
      return {
        locationOptionCode: this.item?.dfDefinitionCategoryCode,
        locationOptionNo: this.item?.categoryOptionNo,
        defectOptionCode: this.defectOptionCode,
        defectOptionNo: this.defectSeverityMap[this.defectOptionCode]
          ?.categoryOptionNo,
      };
    },
    validate() {
      return !!this.defectOptionCode;
    },
  },
};
</script>
<style lang="scss" scoped>
.defect-serverity {
  border: 1px solid #efefef;
  margin-bottom: 10px;
  .defect-serverity-item {
    border-bottom: 1px solid #efefef;
    height: 40px;
    font-size: 14px;
    display: flex;
    :last-child {
      border-bottom: 0px !important;
    }
    .label {
      border-right: 1px solid #efefef;
      width: 120px;
      height: 39px;
      background-color: #fafafa;
      color: #999a9f;
      display: flex;
      align-items: center;
      padding-left: 10px;
      font-weight: 400;
    }
    .value {
      color: #101010;
      display: flex;
      align-items: center;
      padding-left: 10px;
    }
  }
}
</style>
